import { create } from 'zustand'

import { isDebug } from '@core/debug'
import type { GetState, NamedSet, UseBoundStore } from '@core/zustand'
import { createContext } from '@core/zustand'

import type { EmbedFeedActions } from './actions'
import { createEmbedFeedActions } from './actions'
import { addDevtool } from './helpers'
import type { EmbedFeedInitialState } from './state'
import { createEmbedFeedState } from './state'

export type EmbedFeedState = EmbedFeedInitialState & {
  actions: EmbedFeedActions
}

export type StateCreator = (
  set: NamedSet<EmbedFeedState>,
  get: GetState<EmbedFeedState>,
) => EmbedFeedState

/**
 * Creates a zustand store for EmbedFeed widget
 *
 * @returns A zustand store
 */
export const createStore = (): UseBoundStore<EmbedFeedState> => {
  let createState: StateCreator = (
    set: NamedSet<EmbedFeedState>,
    get: GetState<EmbedFeedState>,
  ): EmbedFeedState => ({
    ...createEmbedFeedState(),
    actions: createEmbedFeedActions(set, get),
  })

  // Note: devtool must be configured before other middleware.
  if (isDebug()) {
    createState = addDevtool(createState)
  }

  return create<EmbedFeedState>(createState)
}

export const { Provider, useStore, useStoreApi, useStoreApiOptional } =
  createContext<EmbedFeedState>()
